
import DataEmpty from "@/views/components/DataEmpty/DataEmpty.vue";
import {Component, Vue, Watch} from "vue-property-decorator";
import {ProgressBar} from "@/views/components";
import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
import config from "./config";
import TableHeader from "./TableHeader.vue";
import {getOrgInfo, HbPrint, hbPrintList, queryOrgInfo, queryUserInfo, saveBagOrg} from "@/api/print";
import {LogHelper} from "@/common/LogHelper";
import dayjs from "dayjs";
import {SystemConfigModule} from "@/store/modules/store_systemconfig";
import { PaperSizeEnum, PaperSizeOptions } from "@/common/enum/paper-size";
import { PrintUtils } from "@/common/print-utils";
import {newCheckWanted, queryAllDevices} from "@/api/service";

@Component({
  name: "InboundVirtualPacketPrint",
  computed: {
    PaperSizeOptions() {
      return PaperSizeOptions
    }
  },
  components: {
    YtoTable,
    TableHeader,
    ProgressBar,
    DataEmpty,
  },
})
export default class extends Vue {
  private hbPrintListReqVo: any = {
    hbType: 1
  }

  private hasPaperSizeOption: boolean = false;
  private hasThreeCodeSearch: boolean = false;
  private selectItem = [];

  @Watch("inputModel.input_NameType", {deep: false})
  onPackageNameChanged(val: string, oldVal: string) {
    debugger;
    this.printDataResultShowList = [];
    this.inputModel.input_OrgCodeName = '';
    this.inputModel.input_UserCode = '';
    this.inputModel.input_ThreeCode = '';
    if (this.latticeSchemeName.length === 0 )
    {
      this.inputModel.input_LatticeSchemeName = "";
    }
    else
    {
      this.inputModel.input_LatticeSchemeName = this.latticeSchemeName[0].value;
    }

    var idx = this.selectoplist.findIndex((currentValue, index, arr) => {
      return arr[index].value == val;
    }, val)
    this.hbPrintListReqVo = {
      hbType: idx + 1
    };
    if (val === "CenterCodeName") {
      this.orgCodeDisabled = true;
      this.inputModel.input_OrgCodeName = "";
      this.table1Loading = true;
      setTimeout(() => {
        let getOrgInfoRequest = {
          devMac: this.globalConfig.LocalMac,
          devType: "0",
          body: {
            queryValue: "",
            queryType: "5",
            viewType: "1",
            extend1: this.loginData.orgCode,
            extend2: "", //OrgCode
            extend3: "",
          },
        };
        var orgs = getOrgInfo(JSON.stringify(getOrgInfoRequest));
        var resultData = JSON.parse(orgs);
        if (resultData.respcode === "000") {
          // this.printDataResultShowList = resultData.data;
          if (resultData.data != null) {
            let _data = JSON.parse(resultData.data);
            var newArray = _data?.map(function (item) {
              return {
                countNum: "",
                // ID: item.ID,
                orgName: item.orgName,
                orgCode: item.orgCode,
                printKeyWord: item.printKeyWord,
                matchCode: item.matchCode,
                subdivisionCode: item.subdivisionCode,
                printCount: item.printCount,
                // Count: item.Count,
                edit: false,
                item: item
              };
            });
            this.printDataResultShowList = newArray;
          }
        }
        this.table1Loading = false;
      }, 500);
    }

    if (val === 'SearchByAllUser') {
      if (this.globalConfig.CurrentOrgType !== 'TRANSFER_CENTER') {
        this.inputModel.input_OrgCodeName = this.loginData.orgCode + ' ' + this.loginData.orgName;
        this.hbPrintListReqVo.orgCode = this.loginData.orgCode;
        this.hbPrintListReqVo.orgName = this.loginData.orgName;
        this.queryprintList()
      }
    }
  }

  public globalConfig: any = {};
  public loginData: any = {};
  public defaultPrinter = "";
  public selectoplist = [
    {label: '按全量目的地', value: 'CenterCodeName'},
    {label: '按单个目的地（精准查询）', value: 'OrgCodeName'},
    {label: '按业务员查询', value: 'SearchByAllUser'},
    // {label: '按单个业务员（精准查询）', value: 'SearchBySingleUser'},
    // {label: '按三段码查询', value: 'SearchByThreeCode'},
  ];

  created() {
    this.orgCodeDisabled = true;
    this.inputModel.input_NameType = "CenterCodeName";
    this.table1Loading = true;
  }

  mounted() {
    try {
      LogHelper.Console("新版本进港虚拟包签打印");
      LogHelper.Console("获取全局配置信息");
      this.globalConfig = SystemConfigModule.globalData;
      this.loginData = SystemConfigModule.loginData;
      this.hasPaperSizeOption = PrintUtils.hasPaperSizeOption();
      this.inputModel.input_PaperSize = this.hasPaperSizeOption ? PrintUtils.getDefaultPaperSize() : "";
      //注册查询打印结果数据回传
      obj_InboundVirtualPacketPrint.regist_PrintedDataCallback(
        this.PrintedDataCallback
      );
      //注册回传打印数量
      obj_InboundVirtualPacketPrint.regist_PrintedCountCallback(
        this.PrintedCountCallback
      );
      this.hasThreeCodeSearch = PrintUtils.hasThreeCodeSearch();

      //add by klm 20230905
      debugger;
      LogHelper.Console("是否按三段码查询" + this.hasThreeCodeSearch);
      if (!this.hasThreeCodeSearch)
      {
        this.selectoplist.push({label: '按单个业务员（精准查询）', value: 'SearchBySingleUser'});
      }
      else
      {
        this.selectoplist.push({label: '按三段码查询', value: 'SearchByThreeCode'});
      }

      this.getCrossDeviceName();


      if (this.latticeSchemeName.length === 0 )
      {
        this.inputModel.input_LatticeSchemeName = "";
      }
      else
      {
        this.inputModel.input_LatticeSchemeName = this.latticeSchemeName[0].value;
      }

    } catch (error) {
      LogHelper.Console("进港虚拟包签打印界面:注册回调函数异常" + error);
    }
  }

  private getCrossDeviceName()
  {
    try {
      debugger;
      //获取交叉带相关信息
      let Request = {
        devMac: this.globalConfig.LocalMac,
        devType: this.globalConfig.CurrentDeviceType.toString(),
        "body": {
          "queryValue": null,
          "queryType": null,
          "viewType": null,
          "extend1": null,
          "extend2": null,
          "extend3": null
        }
      };
      let ResponseStr = queryAllDevices(
        JSON.stringify(Request)
      );
      let Response = JSON.parse(ResponseStr);
      let data = JSON.parse(Response.data);

      for (let i = 0; i < data.length; i++) {
        this.latticeSchemeName.push({
          value:data[i].latticeSchemeId,
          label:data[i].deviceName+"-"+data[i].latticeScheme
        });
      }
    }catch (e) {

    }
  }

  private handleSelectFormItem(type, item) {
    // if (this.hasThreeCodeSearch && this.hbPrintListReqVo.hbType == 3 && (type == 1 || type == 2))
    // {
    //   debugger;
    //   this.selectItem = item;
    //   return;
    // }
    this.selectItem = item;
    debugger;
    if (type == 1) {
      this.hbPrintListReqVo.orgCode = item.code;
      this.hbPrintListReqVo.orgName = item.name;

    }
    if (type == 3)
    {
      this.hbPrintListReqVo.empCode = "";
      this.hbPrintListReqVo.empName = "";
    }
    if (type == 2) {
      debugger;
      this.hbPrintListReqVo.empCode = item.code;
      this.hbPrintListReqVo.empName = item.name;
      if (!this.hasThreeCodeSearch)
      {
        this.inputModel.input_OrgCodeName = item.belongOrg + ' ' + item.extend1;
        this.hbPrintListReqVo.orgCode = item.belongOrg;
        this.hbPrintListReqVo.orgName = item.extend1;
      }
    }
    if (this.hasThreeCodeSearch && (this.hbPrintListReqVo.hbType == 3 || this.hbPrintListReqVo.hbType == 4) )
    {
      if ((type == 3 || type == 4))
      {
        this.queryprintList();
      }
    }
    else
    {
      this.queryprintList();
    }

  }

  private queryprintList() {
    debugger
    if (this.hbPrintListReqVo.orgCode && (this.hbPrintListReqVo.empCode || this.hbPrintListReqVo.hbType == 2 || this.hbPrintListReqVo.hbType == 3 || (this.hbPrintListReqVo.hbType == 4 && this.hasThreeCodeSearch))) {
      //如果当前所选项为按三段码查询，则该值赋值为5
      var tmp = JSON.parse(JSON.stringify(this.hbPrintListReqVo))
      if (tmp.hbType == 4 && this.hasThreeCodeSearch)
      {
        tmp.hbType = 5;
        tmp.latticeSchemeId = this.inputModel.input_LatticeSchemeName;

        //大头笔处理
        let inputThreeCode = this.inputModel.input_ThreeCode;
        let threeCodeTmp = "";
        if (inputThreeCode.includes("\n")) {
          let valueArray = inputThreeCode.split("\n");
          valueArray.forEach((element) => {
            if (element.length > 0) {
              threeCodeTmp += element + ",";
            }
          });
          if (threeCodeTmp.length > 0) {
            threeCodeTmp = threeCodeTmp.substr(0, threeCodeTmp.length - 1);
          }
        }
        else
        {
          threeCodeTmp = inputThreeCode;
        }
        tmp.daTouBi = threeCodeTmp;

      }

      let res = hbPrintList(tmp);
      if (this.hbPrintListReqVo.hbType == 1 || this.hbPrintListReqVo.hbType == 2) {
        let _data = JSON.parse(res.data);
        var newArray = _data?.map(function (item) {
          return {
            countNum: "",
            // ID: item.ID,
            orgName: item.orgName,
            orgCode: item.orgCode,
            printKeyWord: item.printKeyWord,
            matchCode: item.matchCode,
            subdivisionCode: item.subdivisionCode,
            printCount: item.printCount,
            latticeNo: item.latticeNo,
            edit: false,
            item: item
          };
        });
        this.printDataResultShowList = newArray;
      } else {
        let _data = JSON.parse(res.data);
        var newArray = _data?.map(function (item) {
          return {
            countNum: "",
            // ID: item.ID,
            orgName: item.empName,
            orgCode: item.empCode,
            printKeyWord: item.printKeyWord,
            matchCode: item.matchCode,
            subdivisionCode: item.subdivisionCode,
            printCount: item.printCount,
            latticeNo: item.latticeNo,
            edit: false,
            item: item
          };
        });
        this.printDataResultShowList = newArray;
      }
    }
  }

  private orgfetch(qs, cb) {
    if (!qs) {
      cb([])
    } else {
      this.hbPrintListReqVo.orgCode = "";
      this.hbPrintListReqVo.orgName = "";
      console.log('orgfetch:' + qs)
      var res = queryOrgInfo({
        "devMac": this.globalConfig.LocalMac,
        "devType": this.globalConfig.CurrentDeviceType.toString(),
        "body": {
          "extend1": null,
          "extend2": null,
          "extend3": null,
          "queryType": "0",
          "queryValue": qs,
          "viewType": null
        }
      })
      if (res.respcode === '000') {
        let data = JSON.parse(res.data);
        let items = [];
        for (let i = 0; i < data.length; i++) {
          let e = data[i];
          e.value = e.codeAndName;
          // items.push({value: e.codeAndName, item: e})
          items.push(e)
        }
        cb(items);
      }
    }
  }

  private userfetch(qs, cb) {
    if (!qs) {
      cb([])
    } else {
      this.hbPrintListReqVo.empCode = "";
      this.hbPrintListReqVo.empName = "";
      console.log('userfetch:' + qs)
      var res = queryUserInfo({
        "devMac": this.globalConfig.LocalMac,
        "devType": this.globalConfig.CurrentDeviceType.toString(),
        "body": {
          "extend1": null,
          "extend2": null,
          "extend3": null,
          "queryType": "0",
          "queryValue": qs,
          "viewType": null
        }
      })
      if (res.respcode === '000') {
        let data = JSON.parse(res.data);
        let items = [];
        for (let i = 0; i < data.length; i++) {
          let e = data[i];
          e.value = e.codeAndName;
          // items.push({value: e.codeAndName, item: e})
          items.push(e)
        }
        cb(items);
      } else {
        this.$message.error('')
      }
    }
  }

  private getDefaultPrinter() {
    var printersStr = obj_Printer_Core.getAllPrinters();
    if (printersStr == null || printersStr.length == 0) {
      return;
    }
    var printers = JSON.parse(printersStr);

    printers.forEach((element) => {
      let printName = element.printName;
      let defultPrinter = false;
      // let workOffline = false;
      element.propertyDatas.forEach((_element) => {
        if (_element.Name === "Default" && _element.Value === true) {
          this.defaultPrinter = printName;
          LogHelper.Console("默认打印机:");
          LogHelper.Console(this.defaultPrinter);
          return;
        }
      });
    });
  }

  private tableRowClassName({row, rowIndex}) {
    row.row_index = rowIndex;
  }

  private SearchOrgCodeNameFunc() {
    // this.table1Loading = true;
    var searchKey = this.inputModel.input_OrgCodeName;
    if (searchKey == "") {
      this.$message.error("请输入目的地名称或代码");
      return;
    }

    setTimeout(() => {
      let getOrgInfoRequest = {
        devMac: this.globalConfig.LocalMac,
        devType: "0",
        body: {
          queryValue: "",
          queryType: "5",
          viewType: "1",
          extend1: "",
          extend2: searchKey, //OrgCode
          extend3: "",
        },
      };
      var orgs = getOrgInfo(JSON.stringify(getOrgInfoRequest));
      var resultData = JSON.parse(orgs);
      if (resultData.respcode === "000") {
        if (resultData.data.length > 0) {
          let _data = JSON.parse(resultData.data);
          this.printDataResultShowList = _data;
        }
      }
      // this.table1Loading = false;
    }, 500);
  }

  private printCount = 0;
  private totalCount = 0;

  private inputModel: inputDataModel_InboundVirtualPacketPrint = {
    input_NameType: "", input_OrgCodeName: "", input_UserCode: "", input_PaperSize: "", input_LatticeSchemeName:"",input_ThreeCode:"",
  };

  public table1Loading = false;
  private progressBarDialogTitle = "";

  private async PrintedCountCallback(
    printedCount,
    totalCount,
    loadingEnable,
    title
  ) {
    return new Promise((resolve) => {
      setTimeout(() => {
        this.printCount = printedCount;
        this.totalCount = totalCount;
        this.proressBarDialogShow = loadingEnable;
        this.progressBarDialogTitle = title;
        resolve("success");
      }, 300);
    });
  }

  private proressBarDialogShow = false;
  private items = [];

  //打印按钮
  private SubmitPrintFunc() {
    debugger
    if (this.hbPrintListReqVo.hbType == 4 && !this.inputModel.input_UserCode && !this.hasThreeCodeSearch) {
      this.$message.error('请输入业务员工号或名称')
      return;
    }
    if ((this.hbPrintListReqVo.hbType == 2 || this.hbPrintListReqVo.hbType == 3) && !this.inputModel.input_OrgCodeName) {
      this.$message.error('请输入网点代码或名称')
      return;
    }
    this.getDefaultPrinter();
    // obj_InboundVirtualPacketPrint.submitPrint(this.multipleSelection);
    let printlist = this.multipleSelection;
    if (printlist == null || printlist.length < 1) {
      this.$message.error("请重新选择打印项,或者重新输入数量");
      return;
    }
    this.items = [];
    let totalCount = 0;
    let singleCount = 0;

    try {
      printlist.forEach((item) => {
        try {
          singleCount = Number.parseInt(item.countNum.toString());
        } catch (ex) {
          this.$message.error("输入数据有误,请重新输入数量");
          throw new Error("EndIterative");
        }
        if (singleCount > 500) {
          this.$message.error("单项的打印数量超过500张,请重新输入数量");
          throw new Error("EndIterative");
        }
        totalCount = totalCount + singleCount;
      });
    } catch (error) {
      if (error.message == "EndIterative") {
        return;
      }
    }

    if (totalCount > 10000) {
      this.$message.error("打印的总数超过10000张,请重新输入需要打印的数量");
      return;
    }

    //收集打印请求
    printlist.forEach((item) => {
      singleCount = Number.parseInt(item.countNum.toString());

      this.items.push({
        IsSelected: true,
        PrintCount: singleCount,
        OrgCode: item.orgCode == null ? "" : item.orgCode.toString(),
        MatchCode: item.matchCode == null ? "" : item.matchCode.toString(),
        OrgName: item.orgName == null ? "" : item.orgName.toString(),
        SubdivisionCode:
          item.subdivisionCode == null ? "" : item.subdivisionCode.toString(),
        PrintKeyWord:
          item.printKeyWord == null ? "" : item.printKeyWord.toString(),
        LatticeNo:
          item.latticeNo == null ? "" : item.latticeNo.toString(),
        item: item
      });
    });
    if (this.items.length > 0) {
      LogHelper.Print("进港虚拟包签打印开始");
      this.PrintRequest();
    }
  }

  //按三段码查询
  private SearchResultFunc() {

    if(this.hbPrintListReqVo.hbType == 4 )
    {
      if(this.inputModel.input_LatticeSchemeName == "")
      {
        this.$message.error("未选交差带格口方案名称");
        return;
      }
      debugger;
      console.log("当前三段码输入框回车数量：" + this.inputModel.input_ThreeCode.split('\n').length)
      if (this.inputModel.input_ThreeCode.split('\n').length > 10)
      {
        this.$message.error("当前查询三段码数量过多，一次查询不超过10个");
        return;
      }
      this.hbPrintListReqVo.orgCode = this.loginData.orgCode;
      this.hbPrintListReqVo.orgName = this.loginData.orgName;
      this.queryprintList();
    }
    else if (this.hbPrintListReqVo.hbType == 3 )
    {
      debugger;
      if(this.inputModel.input_OrgCodeName == "")
      {
        this.$message.error("目的网点代码名称不能为空");
        return;
      }
      else if(this.inputModel.input_OrgCodeName !== "" && this.inputModel.input_UserCode !== "")
      {
        this.handleSelectFormItem(4, this.selectItem);
      }
      else if (this.inputModel.input_OrgCodeName !== "" && this.inputModel.input_UserCode == "")
      {
        this.handleSelectFormItem(3, this.selectItem);
      }
    }
  }

  public IsPainting = false;

  public async PrintRequest() {
    if (this.IsPainting) {
      this.$message.error("虚拟包签正在打印中，请勿重复打印");
      return;
    }
    try {
      this.IsPainting = true;
      if (this.items == null) {
        return;
      }
      var b = this.items.some((f) => f.IsSelected && f.PrintCount > 0);
      if (b) {
        let hBPrintRequests = [];
        let _item = this.items.filter((f) => f.IsSelected);
        _item.forEach((getPrintItem) => {
          console.log(getPrintItem)
          if (getPrintItem.PrintCount > 0 && getPrintItem.PrintCount <= 500) {
            let hbType: any = (this.hbPrintListReqVo.hbType - 1) / 2;
            hBPrintRequests.push({
              createUserCode: this.loginData.userCode,
              createUserName: this.loginData.userName,
              num: getPrintItem.PrintCount,
              orgCode: getPrintItem.item.item.orgCode,
              hbType: parseInt(hbType),
              empCode: getPrintItem.item.item.empCode,
              empName: getPrintItem.item.item.empName,
            });
          } else {
            this.$message.error("打印的数量小于0,或者大于500");
            hBPrintRequests = [];
            this.IsPainting = false;
            return;
          }
        });

        console.log(hBPrintRequests)
        let obj = JSON.parse(HbPrint(JSON.stringify(hBPrintRequests)));
        if (obj?.respcode == "000" && obj?.data != null) {
          let printList = [];
          obj.data.forEach((response) => {
            let _this = this;
            let getOrgInfoResponse = this.items.filter(
              (item) => {
                if (this.hbPrintListReqVo.hbType == 3 || this.hbPrintListReqVo.hbType == 4) {
                  return item.item.item.empCode == response.empCode
                } else {
                  return item.OrgCode == response.orgCode
                }
              }
              , this)[0];
            this.ShowPreprintData(getOrgInfoResponse);

            if (getOrgInfoResponse != null) {
              // getOrgInfoResponse.HbNoList = response.hbNoList;
              response.hbNoList.forEach((element) => {
                let _getOrgInfoResponse = JSON.parse(
                  JSON.stringify(getOrgInfoResponse)
                );
                _getOrgInfoResponse.WaybillNo = element;
                printList.push(_getOrgInfoResponse);
              });
              // setTimeout(() => {

              // }, 10);
            }
          });
          this.OnPrint(printList);
          PrintUtils.savePaperSize(this.inputModel.input_PaperSize);
        }
      } else {
        this.$message.error("请先选择需要打印的项，或者输入预打印\r\n的数量");
      }

      this.IsPainting = false;
    } catch (ex) {
      LogHelper.Print("虚拟包签打印方法Onpaint出现异常" + ex);
      this.IsPainting = false;
    } finally {
      this.IsPainting = false;
    }
  }

  private ShowPreprintData(item) {
    if (
      this.HBPrintedItems.some(
        (f) =>
          f.DestOrgName == item.OrgName &&
          f.DestOrgCode == item.OrgCode &&
          f.ThreeCode == item.MatchCode &&
          f.CenCode == item.CenCode &&
          f.PrintKeyWord == item.PrintKeyWord &&
          f.SubdivisionCode == item.SubdivisionCode &&
          f.LatticeNo == item.LatticeNo
      )
    ) {
      let first = this.HBPrintedItems.filter(
        (f) =>
          f.DestOrgName == item.OrgName &&
          f.DestOrgCode == item.OrgCode &&
          f.ThreeCode == item.MatchCode &&
          f.CenCode == item.CenCode &&
          f.PrintKeyWord == item.PrintKeyWord &&
          f.SubdivisionCode == item.SubdivisionCode &&
          f.LatticeNo == item.LatticeNo
      )[0];
      // if (index == 0) {
      first.PrePrintTotal = first.PrePrintTotal + item.PrintCount;
      // }
    }
  }

  private getTemplateName(item) {
    debugger;
    let file = "";
    if (!this.hasThreeCodeSearch || this.hbPrintListReqVo.hbType !== 4)
    {
      if (item.SubdivisionCode == null || item.SubdivisionCode.length < 1) {
        file = "\\PrintTemplate\\InboundVirtualPacketLabelNormal";
      } else {
        file = "\\PrintTemplate\\InboundVirtualPacketLabel";
      }
    }
    else
    {
      if (item.SubdivisionCode == null || item.SubdivisionCode.length < 1) {
        file = "\\PrintTemplate\\InboundVirtualPacketNum";
      } else {
        file = "\\PrintTemplate\\InboundVirtualPacketNumNormal";
      }
    }


    file = PrintUtils.buildTemplateNameByPaperSize(file, this.inputModel.input_PaperSize);
    file += ".frx";

    return file;
  }

  private HBPrintedItems = [];

  private async OnPrint(item) {
    try {
      if (item.length == 0) {
        return;
      }
      LogHelper.Print(
        "虚拟包签打印" +
        this.loginData.orgName +
        "打印开始:" +
        "共有" +
        item.length +
        "张"
      );

      //给展示控件赋值
      this.printCount = 0;
      this.totalCount = item.length;
      this.proressBarDialogShow = true;
      this.progressBarDialogTitle = "打印中";
      LogHelper.Console("打开流程框");
      //给展示控件赋值结束

      await this.printStart(item);

      LogHelper.Print("虚拟包签打印" + this.loginData.orgName + "打印结束");
    } catch (ex) {
      LogHelper.Print("打印出错:" + ex);
    }
  }

  //开始打印
  private async printStart(item) {
    debugger
    for (let index = 0; index < item.length; index++) {
      //异步展示打印数量
      await this.ShowAsync(index);
      this.printOne(index, item[index]);
    }
    this.progressBarDialogTitle = "打印结束";
    this.proressBarDialogShow = false;
    LogHelper.Console("关闭流程框");
  }

  //打印单条数据
  private printOne(index, item) {
    try {
      if (obj_LocalData_Core.isBagNoPrinted(item.WaybillNo)) {
        obj_LocalData_Core.insertBagPrintDetail(
          item.WaybillNo,
          dayjs().valueOf().toString(),
          1,
          2,
          "虚拟包签号码出现重复"
        );
        LogHelper.Print(
          "虚拟包签打印发现重复:" +
          "WayBillNo:" +
          item.WaybillNo +
          ",已经跳过打印"
        );
        return;
      }
      LogHelper.Print(
        "虚拟包签开始打印，SrcOrgCode：" +
        this.loginData.orgName +
        "PrintTime：" +
        dayjs().format("YYYY-MM-DD") + // DateTime.Now.ToString("yyyy-MM-dd")}  " +
        "WayBillNo：" +
        item.WaybillNo +
        "PackageName：" +
        item.MatchCode +
        "PrintKeyWord：" +
        item.PrintKeyWord +
        "UnpackOrgName：" +
        item.OrgName +
        "UnpackOrgCode：" +
        item.OrgCode +
        "SubdivisionCode：" +
        item.SubdivisionCode
      );

      let templatePath = this.getTemplateName(item);
      var _data = {
        SrcOrgCode: "",
        PrintTime: "",
        WayBillNo: "",
        PackageName: "",
        UnpackOrgName: "",
        UnpackOrgCode: "",
        SubdivisionCode: "",
        LatticeNo:"",
      };
      let printKeyWord =
        item.PrintKeyWord.trim() == ""
          ? item.OrgName.trim()
          : item.PrintKeyWord.trim();
      _data.SrcOrgCode = this.loginData.orgName.trim();
      _data.PrintTime = dayjs().format("YYYY-MM-DD");
      _data.WayBillNo = item.WaybillNo.trim();
      _data.PackageName = item.MatchCode.trim();
      _data.UnpackOrgName = printKeyWord;
      _data.UnpackOrgCode = item.OrgCode.trim();
      _data.SubdivisionCode = item.SubdivisionCode.trim();
      _data.LatticeNo = item.LatticeNo.trim();
      var array = [];
      array.push(_data);
      var result = obj_Printer_Core.print(
        JSON.stringify(array),
        templatePath,
        this.defaultPrinter
      );
      debugger;
      if (
        this.HBPrintedItems.some(
          (f) =>
            f.DestOrgName == item.OrgName &&
            f.DestOrgCode == item.OrgCode &&
            f.ThreeCode == item.MatchCode &&
            f.CenCode == item.CenCode &&
            f.PrintKeyWord == item.PrintKeyWord &&
            f.SubdivisionCode == item.SubdivisionCode
        )
      ) {
        let first = this.HBPrintedItems.filter(
          (f) =>
            f.DestOrgName == item.OrgName &&
            f.DestOrgCode == item.OrgCode &&
            f.ThreeCode == item.MatchCode &&
            f.CenCode == item.CenCode &&
            f.PrintKeyWord == item.PrintKeyWord &&
            f.SubdivisionCode == item.SubdivisionCode
        )[0];
        // if (index == 0) {
        // first.PrePrintTotal = first.PrePrintTotal + 1;
        // }

        first.PrintedCount = first.PrintedCount + 1;
        //this.PrintResultView.Invalidate();
      } else {
        var i = {
          DestOrgName: item.OrgName,
          DestOrgCode: item.OrgCode,
          FailedCount: 0,
          CenCode: item.CenCode,
          CenName: item.CenName,
          PrePrintTotal: item.PrintCount,
          PrintedCount: 1,
          ThreeCode: item.MatchCode,
          SubdivisionCode: item.SubdivisionCode,
          PrintKeyWord: item.PrintKeyWord,
        };
        this.HBPrintedItems.unshift(i);
        //this.PrintResultView.Invalidate();
      }
      obj_LocalData_Core.insertBagPrintDetail(
        item.WaybillNo,
        dayjs().valueOf().toString(),
        1,
        1,
        "虚拟包签打印成功"
      );
      LogHelper.Print(
        "虚拟包签打印第" +
        (index + 1) +
        "张打印结束:" +
        "WayBillNo:" +
        item.WaybillNo
      );
    } catch (e) {
      obj_LocalData_Core.insertBagPrintDetail(
        item.WaybillNo,
        dayjs().valueOf().toString(),
        1,
        2,
        e.toString()
      );
      LogHelper.Print("打印出错:" + e);

      if (
        this.HBPrintedItems.some(
          (f) =>
            f.DestOrgName == item.OrgName &&
            f.DestOrgCode == item.OrgCode &&
            f.ThreeCode == item.MatchCode &&
            f.CenCode == item.CenCode
        )
      ) {
        let first = this.HBPrintedItems.filter(
          (f) =>
            f.DestOrgName == item.OrgName &&
            f.DestOrgCode == item.OrgCode &&
            f.ThreeCode == item.MatchCode &&
            f.CenCode == item.CenCode
        )[0];
        // if (index == 0) {
        // first.PrePrintTotal = first.PrePrintTotal + 1;
        // }
        first.FailedCount = first.FailedCount + 1;
        //this.PrintResultView.Invalidate();
      } else {
        var i = {
          DestOrgName: item.OrgName,
          DestOrgCode: item.OrgCode,
          FailedCount: 1,
          CenCode: item.CenCode,
          CenName: item.CenName,
          PrePrintTotal: item.PrintCount,
          PrintedCount: 0,
          ThreeCode: item.MatchCode,
          SubdivisionCode: item.SubdivisionCode,
          PrintKeyWord: item.PrintKeyWord,
        };
        this.HBPrintedItems.unshift(i);
        //this.PrintResultView.Invalidate();
      }
    }

    setTimeout(() => {
      this.PrintedDataCallback(this.HBPrintedItems);
    }, 10);

    // }
  }

  //展示打印进度
  public async ShowAsync(index) {
    return new Promise((resolve) => {
      setTimeout(() => {
        this.printCount = index + 1;
        resolve("success");
      }, 300);
    });
  }

  private progressBarFormCloseFunc() {
  }

  public orgCodeDisabled = true;
  public options = [
    {
      value: "",
      label: "",
    },
  ];
  // public latticeSchemeName = [
  //   {
  //     value: "",
  //     label: "",
  //   },
  // ];
  public  latticeSchemeName= [];


  private loadingshowFunc() {
  }

  private currentRowIndex = "";

  private PrintedDataCallback(printedDatas) {
    console.log(printedDatas)
    this.searchResultShowList = printedDatas;
  }

  private onRowClick(row, event, column) {
    this.currentRowIndex = row.row_index;
  }

  private handelSelectPrintRow(selection, row, index) {
    this.multipleSelection = selection;
    this.$nextTick(() => {
      var el = document.getElementById("editinput" + row.row_index);
      this.selectElementContents(el);
    });
  }

  private requestDataModel: any = {
    orgName: "",
    orgCode: "",
    subdivisionCode: "",
    printKeyWord: "",
  };

  private getFocus(row) {
    this.requestDataModel = {
      orgCode: row.orgCode,
      orgName: row.orgName,
      subdivisionCode: row.subdivisionCode,
      printKeyWord: row.printKeyWord,
    };
  }

  private loseFocus(row) {
    var _requestDataModel = this.requestDataModel;
    if (
      row.orgCode !== _requestDataModel.orgCode ||
      row.printKeyWord !== _requestDataModel.printKeyWord ||
      row.subdivisionCode !== _requestDataModel.subdivisionCode
    ) {
      try {
        // if (_requestDataModel.subdivisionCode!= null && _requestDataModel.subdivisionCode.length>0 &&!System.Text.RegularExpressions.Regex.IsMatch(SubdivisionCode, "^[0-9A-Z]+$"))
        // if (row.subdivisionCode != null && row.subdivisionCode.length > 0) {
        //   this.$message.error("输入字符串不规范,请输入字母或者数字");
        //   return;
        // }

        LogHelper.Print("虚拟包签开始进行保存");
        let saveBagOrgRequest = {
          devMac: this.globalConfig.LocalMac,
          devType: this.globalConfig.CurrentDeviceType.toString(),
          body: [],
        };

        saveBagOrgRequest.body.push({
          orgCode: row.orgCode,
          orgName: row.printKeyWord,
          extend1: row.subdivisionCode,
          extend2: "",
          extend3: "",
        });
        LogHelper.Print(
          "虚拟保包签保存:OrgCode:" +
          row.orgCode +
          ",OrgName:" +
          row.printKeyWord +
          ",SubdivisionCode:" +
          row.subdivisionCode
        );

        var response = JSON.parse(
          saveBagOrg(JSON.stringify(saveBagOrgRequest))
        );
        if (response.respcode != "000") {
          LogHelper.Print(
            "保存虚拟包签组织与代码出现异常,错误原因是：" + response.respMessage
          );
          this.$message.error(
            "保存虚拟包签组织与代码出现异常,错误原因是：" + response.respMessage
          );
        } else {
          LogHelper.Print("保存虚拟包签组织与代码成功");
        }
      } catch (ex) {
        LogHelper.Print("保存虚拟包签组织与代码出现异常" + ex.Message);
      }
    }
  }

  // private cellClick(row, column) {
  //   row.seen = true;
  // }

  private printDataResultShowList = [
    // {
    //   ID: "",
    //   Name: "嘉峪关中转包-934",
    //   UnpackOrgName: "甘肃嘉峪关接驳点",
    //   Type: "汽运",
    //   edit: false,
    //   Count: "",
    //   UnpackOrgCode: ""
    // }
  ];
  public multipleSelection = [];

  public handleSelectionChange(val) {
    this.multipleSelection = val;
    // if (val.length == 0) {
    //   for (
    //     let index = 0;
    //     index < this.printDataResultShowList.length;
    //     index++
    //   ) {
    //     this.printDataResultShowList[index].edit = false;
    //   }
    // }
  }

  private searchResultShowList = [];

  //获得焦点，选中文本
  private getInputFocus(event): void {
    event.currentTarget.select();
  }

  private config = config;

  public selectElementContents(el) {
    try {
      el.blur();
      el.focus();
    } catch (error) {
      LogHelper.Console("selectElementContents error：" + error);
    }
  }

  public UnpackOrgName = "";
}
